import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/auth';
import { usePermission } from 'hooks/usePermission';
import { cn } from 'lib/utils';
import { TRACKING_V2_ROUTES } from 'lib/routes';

import * as S from './styles';

type Route = {
  title: string;
  path: string;
  blockedRoles?: string[];
  permissions?: string[];
};

const ROUTES: Route[] = [
  {
    title: 'Tracking de notas fiscais',
    path: TRACKING_V2_ROUTES.invoicesTracking().url,
  },
  {
    title: 'Tracking por viagem',
    path: TRACKING_V2_ROUTES.tripsTracking().url,
  },
  {
    title: 'Criar viagem',
    path: TRACKING_V2_ROUTES.createTrip().url,
  },
  {
    title: 'Comprovantes',
    path: TRACKING_V2_ROUTES.deliveryVouchers().url,
    permissions: TRACKING_V2_ROUTES.deliveryVouchers().permissions,
  },
];

export const TabbedNavigation = ({
                                   className,
                                   ...props
                                 }: React.HTMLAttributes<HTMLDivElement>) => {
  const location = useLocation();
  const { hasPermissionTo } = usePermission();
   const { profile } = useAuth();

  const isRouteActive = React.useCallback(
    (path: string) => {
      if (path.includes('#')) {
        const [pathname, hash] = path.split('#');
        return location.pathname === pathname && location.hash === `#${hash}`;
      }

      return location.pathname === path;
    },
    [location.pathname, location.hash],
  );

  return (
    <div {...props} className={cn('flex flex-col w-full mb-6', className)}>
      <S.Container>
        {ROUTES.map((route) => {
          const isRoleBlocked =
            route.blockedRoles?.includes(profile?.type || '') ?? false;

          // Se a rota exigir permissões e o usuário não tiver todas elas, a aba fica oculta.
          const isPermissionBlocked = route.permissions
            ? !hasPermissionTo(route.permissions)
            : false;

          if (isRoleBlocked || isPermissionBlocked) return null;

          return (
            <S.Button
              key={route.path}
              to={route.path}
              className={isRouteActive(route.path) ? 'active' : ''}
            >
              {route.title}
            </S.Button>
          );
        })}
      </S.Container>
    </div>
  );
};
